import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function StatusBadge({ status, size = 'md' }) {
    const getStatusConfig = () => {
        const statusLower = status.toLowerCase();
        // Jira project categories
        if (statusLower === 'active' || statusLower === 'active (billable)') {
            return {
                label: status,
                bgColor: 'bg-green-100',
                textColor: 'text-green-800',
                dotColor: 'bg-green-500',
            };
        }
        if (statusLower === 'active (non-billable)') {
            return {
                label: status,
                bgColor: 'bg-teal-100',
                textColor: 'text-teal-800',
                dotColor: 'bg-teal-500',
            };
        }
        if (statusLower === 'on hold') {
            return {
                label: status,
                bgColor: 'bg-yellow-100',
                textColor: 'text-yellow-800',
                dotColor: 'bg-yellow-500',
            };
        }
        if (statusLower === 'completed') {
            return {
                label: status,
                bgColor: 'bg-blue-100',
                textColor: 'text-blue-800',
                dotColor: 'bg-blue-500',
            };
        }
        if (statusLower === 'cancelled') {
            return {
                label: status,
                bgColor: 'bg-red-100',
                textColor: 'text-red-800',
                dotColor: 'bg-red-500',
            };
        }
        if (statusLower === 'uncategorized') {
            return {
                label: status,
                bgColor: 'bg-gray-100',
                textColor: 'text-gray-800',
                dotColor: 'bg-gray-500',
            };
        }
        // Budget/health statuses
        switch (status) {
            case 'on_track':
                return {
                    label: 'On Track',
                    bgColor: 'bg-green-100',
                    textColor: 'text-green-800',
                    dotColor: 'bg-green-500',
                };
            case 'at_risk':
                return {
                    label: 'At Risk',
                    bgColor: 'bg-amber-100',
                    textColor: 'text-amber-800',
                    dotColor: 'bg-amber-500',
                };
            case 'over_budget':
                return {
                    label: 'Over Budget',
                    bgColor: 'bg-red-100',
                    textColor: 'text-red-800',
                    dotColor: 'bg-red-500',
                };
            case 'delayed':
                return {
                    label: 'Delayed',
                    bgColor: 'bg-orange-100',
                    textColor: 'text-orange-800',
                    dotColor: 'bg-orange-500',
                };
            default:
                return {
                    label: status,
                    bgColor: 'bg-gray-100',
                    textColor: 'text-gray-800',
                    dotColor: 'bg-gray-500',
                };
        }
    };
    const config = getStatusConfig();
    const sizes = {
        sm: {
            badge: 'px-2 py-0.5 text-xs',
            dot: 'w-1.5 h-1.5',
        },
        md: {
            badge: 'px-2.5 py-1 text-sm',
            dot: 'w-2 h-2',
        },
        lg: {
            badge: 'px-3 py-1.5 text-base',
            dot: 'w-2.5 h-2.5',
        },
    };
    return (_jsxs("span", { "data-testid": "status-badge", className: `inline-flex items-center gap-1.5 rounded-full font-medium ${config.bgColor} ${config.textColor} ${sizes[size].badge}`, children: [_jsx("span", { className: `rounded-full ${config.dotColor} ${sizes[size].dot}` }), config.label] }));
}
//# sourceMappingURL=StatusBadge.js.map